<template>
    <div class="tsbx">
        <div class="tsbxc">
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img src="../assets/icon/xqdzb.png" alt="">
                    <span>小区党支部</span>
                </div>
                <div class="giright">
                    <img src="../assets/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img src="../assets/icon/zbsh.png" alt="">
                    <span>支部生活</span>
                </div>
                <div class="giright">
                    <img src="../assets/you.png" alt="">
                </div>
            </div>

        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data() {
        return {
            tp:''
        }
    },
    created () {

    },
    mounted() {

    },
    methods: {
        getidval(name){    
            var url = window.location.href;
            console.log(url)
            let params = url.substr(url.lastIndexOf("?") + 1).split("&");
            for (let i = 0; i < params.length; i++) {
                let param = params[i];
                let key = param.split("=")[0];
                let value = param.split("=")[1];
                if (key === name) {
                return value;
                }
            }
        },
        go(event){
            var that =this
            var name = event.target.innerHTML
            if(name.indexOf('小区党支部') != -1){
                this.$router.push({ path: "/hsyw/dzbdetail", query: {} });
            }
            if(name.indexOf('支部生活') != -1){
                 this.$router.push({ path: "/common/list/zbsh", query: {} });
            } 
            
        }
    },
}
</script>
<style lang="less">
    .tsbx{
        // height: 100%;
        width: 100%;
        display: flex;
        // background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .tsbxc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 15px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 50%;
                    img{
                        margin-left: 20px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse;
                    img{
						display: block;
						height: 18px;
					}
                }
            }
        }
    }
</style>